import { useNavigate } from "react-router";
import { UnderconstructionIllustration } from "vega-illustrations";

import { SecondaryButton } from "@vega-core/components/Buttons/SecondaryButton";
import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { Container } from "@vega-core/components/Layout/Container";
import { usePublicConfig } from "@vega-core/hooks/usePublicConfig";
import { m } from "@vega-core/paraglide/messages";

import { CommonPaths } from "../../paths";

export function PublicPageError() {
  const navigate = useNavigate();
  const isLoginPage = location.pathname.startsWith(CommonPaths.Login);
  const {
    contacts: { helpEmail },
  } = usePublicConfig();

  return (
    <Container>
      <div className="h-dvh flex items-center justify-center">
        <div className="w-full bg-background/secondary flex justify-center p-8 rounded-companyBorderRadius">
          <div className="max-w-[90vw] md:max-w-96 text-center flex flex-col gap-6 items-center">
            <div>
              <UnderconstructionIllustration className="max-w-[100vw]" />
            </div>
            <div className="font-light text-sm text-text/secondary">
              {m.errors_pageCrashedMessage()}
              <a
                className="underline text-brand-default"
                href={`mailto:${helpEmail}`}
              >
                {helpEmail}
              </a>
            </div>
            <div className="w-36">
              <ThemedButton
                dataTestId="refresh-button"
                fullWidth
                onClick={() => location.reload()}
                variant="primary"
              >
                {m.btn_refreshPage()}
              </ThemedButton>
            </div>
            {!isLoginPage ? (
              <SecondaryButton
                dataTestId="return-to-login-button"
                onClick={() => navigate(CommonPaths.Login)}
              >
                {m.btn_returnToLogin()}
              </SecondaryButton>
            ) : null}
          </div>
        </div>
      </div>
    </Container>
  );
}
